import { z } from "zod";

/**
 * AiTaskModelNoticeSchema — an AI-task run answered by a model nobody picked.
 *
 * A stored model id that is not on the live model list (unknown, or deprecated) does
 * not fail the run: its provider's retirement fallback answers instead. The notice is
 * how the caller learns that. `requested` is the id the task or the node names;
 * `servedBy` is the id that ran and was billed.
 *
 * Absent means the run used the model it names. A client that does not know the field
 * ignores it.
 */
export const AiTaskModelNoticeSchema = z.object({
  requested: z.string(),
  servedBy: z.string()
});

export type AiTaskModelNotice = z.infer<typeof AiTaskModelNoticeSchema>;
